import React, { Component } from 'react'
import { connect } from 'react-redux'
import { displayDateTime, displayDate } from '../utils/dateTime'
import { addTargetToLinks } from '../utils/stringOps'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import ShowCategories from './Content/ShowCategories'
import ShowPublished from './Content/ShowPublished'
import ShowAuthor from './Content/ShowAuthor'
import ShowInBrief from './Content/ShowInBrief'
import ShowFullText from './Content/ShowFullText'
import ShowAttachments from './Content/ShowAttachments'
import { AOISTOIGNORE, LANDINGPAGE, EDITORIALACCESS } from '../utils/constants'
import ShowPressSource from './Content/ShowPressSource'
import ShowRelatedContent from './Content/ShowRelatedContent'
import ShowRelatedPortfolios from './Content/ShowRelatedPortfolios'
import ShowPortfolios from './Content/ShowPortfolios'
import ShowAuthorities from './Content/ShowAuthorities'
import ShowCourtsAndJudiciaries from './Content/ShowCourtsAndJudiciaries'
import FilterTimeline from "./ContentFilter/FilterTimeline"
import ShowCompanyOrAuthAdvisers from './Content/ShowCompanyOrAuthAdvisers'
import ShowIssuingEntities from './Content/ShowIssuingEntities'
import ShowDocumentTypes from './Content/ShowDocumentTypes'
import ShowTopics from './Content/ShowTopics'
import ShowContentActionButtons from './Content/ShowContentActionButtons'
import { currentUtcDateTime } from '../utils/dateTime'
import { pushContentToMatomo } from '../utils/matomo'
import aoisData from '../data/aois.json'

var qs = require('qs')
var test = 0
export class Content extends Component {
  constructor(props) {
    super(props)
    this.state = {
      relatedContentsToShow: [],
      selectedContentTypeIds: [],
      selectedGeographyIds: []
    }
  }

  componentDidMount() {
    if (this.props.user && this.props.match.params.id) {
      this.fetchContent(this.props.match.params.id)
      this.fetchPrefs()
    }
  }

  pushLinksClickToMatomo(contentId, contentTitle, contentType, publishedDate, aois) {
    var referrer = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).referrer
    var dailyId = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dailyId
    var contentSetId = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).paddleid
    var contentSetAois = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).paddleaois

    if(contentSetAois != undefined){
      var csaois = contentSetAois.split(";")
      contentSetAois = aoisData.filter(a => csaois.includes(a.id.toString())).map(aoi=> aoi.label)
    }  

    var contextData = {
      contentId: contentId,
      contentTitle: contentTitle,
      contentType: contentType,
      publishedDateTime: publishedDate,
      viewedDateTime: currentUtcDateTime(),
      referral: 'direct',
      aoi: aois.flat(),
      contentSetId: contentSetId == undefined ? 0 : contentSetId,
      contentSetAois: contentSetAois == undefined ? [] : contentSetAois,
    }

    pushContentToMatomo(referrer == undefined ? 'content_directURL' : referrer, 'content', 'content_articlepage', 'click', 'Clickthrough', contextData, dailyId)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.setState({ relatedContentsToShow: [], selectedContentTypeIds: [], selectedGeographyIds: [] })
      this.fetchContent(this.props.match.params.id)
      this.fetchPrefs()
    }
  }

  fetchContent = (id) => {
    const contentId = Number(id)
    this.props.onContentFetch({ id: contentId, apiUrl: process.env.API_URL ?? '' }).then(() => {
      var sourceQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).source 
      
      if(sourceQueryString === undefined || sourceQueryString === ''){
        this.pushLinksClickToMatomo(contentId, this.props.content.title, this.props.content.contentTypeName,
          this.props.content.published, this.props.content.categories.filter(category => category.type === 20).map(cat => cat.name))        
        window.gtag("event", "page_view", {
          page: "/content/" + contentId,
          title: this.props.content.title,
        });        
      }
    })
  }

  fetchPrefs = () => {
    this.props.onPrefsFetch()
  }

  applyContentTypeSelection(isChecked, selectedValue) {
    var selectedContentTypeId = parseInt(selectedValue)
    if (selectedContentTypeId === 0 && isChecked) {
      let filteredRelatedContents = this.state.selectedGeographyIds.length > 0 ?
        this.props.content.relatedContents.filter(content => content.categories.some(c => this.state.selectedGeographyIds.includes(c.id)))
        : this.props.content.relatedContents

      this.setState({ relatedContentsToShow: filteredRelatedContents, selectedContentTypeIds: [] },
        () => this.pushToMatomo('portfolio_filtercontenttype', isChecked, 'filteredContentTypes', this.state.selectedContentTypeIds))
    }
    else {
      if (!isChecked) {
        const selectedContentTypeIds = Array.from(new Set(this.state.selectedContentTypeIds.filter(id => id != selectedContentTypeId)))

        let filteredRelatedContents = selectedContentTypeIds.length > 0 ?
          this.state.relatedContentsToShow.filter(content => selectedContentTypeIds.includes(content.contentType))
          : this.props.content.relatedContents

        // + apply geography filter
        filteredRelatedContents = this.state.selectedGeographyIds.length > 0 ?
          filteredRelatedContents.filter(content => content.categories.some(c => this.state.selectedGeographyIds.includes(c.id)))
          : filteredRelatedContents

        this.setState({ relatedContentsToShow: filteredRelatedContents, selectedContentTypeIds: selectedContentTypeIds },
          () => this.pushToMatomo('portfolio_filtercontenttype', isChecked, 'filteredContentTypes', this.state.selectedContentTypeIds))
      }
      else {
        const selectedContentTypeIds = [...this.state.selectedContentTypeIds, selectedContentTypeId]

        let filteredRelatedContents = this.props.content.relatedContents.filter(content => selectedContentTypeIds.includes(content.contentType))

        // + apply geography filter
        filteredRelatedContents = this.state.selectedGeographyIds.length > 0 ?
          filteredRelatedContents.filter(content => content.categories.some(c => this.state.selectedGeographyIds.includes(c.id)))
          : filteredRelatedContents

        this.setState({ relatedContentsToShow: filteredRelatedContents, selectedContentTypeIds: selectedContentTypeIds },
          () => this.pushToMatomo('portfolio_filtercontenttype', isChecked, 'filteredContentTypes', this.state.selectedContentTypeIds))
      }
    }
  }

  applyGeographySelection(isChecked, selectedValue) {
    var selectedGeographyId = parseInt(selectedValue)
    if (selectedGeographyId === 0 && isChecked) {
      let filteredRelatedContents = this.state.selectedContentTypeIds.length > 0 ?
        this.props.content.relatedContents.filter(content => this.state.selectedContentTypeIds.includes(content.contentType))
        : this.props.content.relatedContents

      this.setState({ relatedContentsToShow: filteredRelatedContents, selectedGeographyIds: [] }, 
          () => this.pushToMatomo('portfolio_filtergeography', isChecked, 'filteredGeographies', this.state.selectedGeographyIds))
    }
    else {
      if (!isChecked) {
        let selectedGeographyIds = Array.from(new Set(this.state.selectedGeographyIds.filter(id => id != selectedGeographyId)))

        // + apply content type filter
        let filteredRelatedContents = this.state.selectedContentTypeIds.length > 0 ?
          this.props.content.relatedContents.filter(content => this.state.selectedContentTypeIds.includes(content.contentType))
          : this.props.content.relatedContents

        filteredRelatedContents = selectedGeographyIds.length > 0 ?
          filteredRelatedContents.filter(content => content.categories.some(c => selectedGeographyIds.includes(c.id))).length > 0 ?
            filteredRelatedContents.filter(content => content.categories.some(c => selectedGeographyIds.includes(c.id))) : filteredRelatedContents
          : filteredRelatedContents

        selectedGeographyIds = filteredRelatedContents.filter(content => content.categories.some(c => selectedGeographyIds.includes(c.id))).length > 0 ?
          selectedGeographyIds : []

        this.setState({ relatedContentsToShow: filteredRelatedContents, selectedGeographyIds: selectedGeographyIds },
          () => this.pushToMatomo('portfolio_filtergeography', isChecked, 'filteredGeographies', this.state.selectedGeographyIds))
      }
      else {
        const selectedGeographyIds = [...this.state.selectedGeographyIds, selectedGeographyId]

        // + apply content type filter
        let filteredRelatedContents = this.state.selectedContentTypeIds.length > 0 ?
          this.props.content.relatedContents.filter(content => this.state.selectedContentTypeIds.includes(content.contentType))
          : this.props.content.relatedContents

        filteredRelatedContents = filteredRelatedContents.filter(content => content.categories.some(c => selectedGeographyIds.includes(c.id)))

        this.setState({ relatedContentsToShow: filteredRelatedContents, selectedGeographyIds: selectedGeographyIds },
          () => this.pushToMatomo('portfolio_filtergeography', isChecked, 'filteredGeographies', this.state.selectedGeographyIds))
      }
    }
  }

  pushToMatomo(uiEvent, uiValue, filterLabel, filterIds){

    var filterValues = []
    if(filterLabel == 'filteredGeographies'){
      var geographies = this.props.content.relatedContents.map(content => {
        return content.categories.filter(catType => filterIds.some(x=> x === catType.id)).map(cat => cat.name)
      }).flat()
  
      filterValues = Array.from(new Set(geographies.map(item => item)))
    }
    else{
      const contentTypes = Array.from(new Set(filterIds))
        .map(ct => {
          return this.props.content.relatedContents.find(c => c.contentType === ct)
        })
        .map(c => c.contentTypeName)
  
      filterValues = Array.from(new Set(contentTypes.map(item => item)))
    }

    var contextData = {
      contentId: this.props.match.params.id,
      [filterLabel] : filterValues
    }

    pushContentToMatomo(uiEvent, 'content', 'content_articlepage', 'click', uiValue, contextData)
  }

  callPdfFetch(request) {
    this.props.onPdfFetch(request)
  }

  render() {
    if (this.props.content.error != '' || (this.props.content.title == '' && this.props.content.fetching === false)) {
      this.props.content.error = ''
      document.title = "MLex | Page Not Found - 404"
      return (
        <div className='grid-content-full content-article'>
          <h1 className='section-header'>Page Not Found - 404</h1>
          <p>We're sorry, but we can't find that page you're looking for.  The content is no longer available or has been moved.</p>
          <div className='inner-container'>
            <a className='pure-button primary-action margin-left-0' href={`/#/${LANDINGPAGE}`} target='_self'>
              Go to Home page
            </a>
          </div>
        </div>
      )
    }
    else {
      if (this.props.user && this.props.match.params.id && this.props.content.categories && this.props.content.fetching === false) {
        var userRole = this.props.user.profile["Role"] != null ? this.props.user.profile["Role"] : ""
        var userEmail = this.props.user.profile["name"]

        if (this.props.content.contentTypeName == 'Portfolio') {
          document.title = "MLex | " + this.props.content.title
          return (
            <>
              <div className='grid-content-header content-article portfolio'>
                <ShowContentActionButtons contentId={this.props.match.params.id} preferences={this.props.preferences}
                  userRole={userRole} userEmail={userEmail} contentTitle={this.props.content.title} isPortfolio onPdfButtonClick={(req) => this.callPdfFetch(req)} apiResponse={this.props.fetchPdf}
                  contentTypeName={this.props.content.contentTypeName} aoi={this.props.content.categories.filter(category => category.type === 20).map(cat => cat.name)}/>

                <h1 className='article-title'>{this.props.content.title || <Skeleton count={2} />}</h1>
                <div className='article-published '>
                  <ShowPublished published={this.props.content.published} contentTypeName={this.props.content.contentTypeName} productType={this.props.user.profile.Product} showTooltip={true} />
                </div>
                <ShowAuthor author={this.props.content.author} clickable={true}/>
              </div>
              <div className='grid-content-aside content-article portfolio'>
                <FilterTimeline relatedContents={this.props.content.relatedContents}
                  selectedContentTypeIds={this.state.selectedContentTypeIds}
                  selectedGeographyIds={this.state.selectedGeographyIds}
                  onContentTypeChanged={(chk, val) => this.applyContentTypeSelection(chk, val)}
                  onGeographyChanged={(chk, val) => this.applyGeographySelection(chk, val)} />
                <ShowAuthorities authorities={this.props.content.relatedContents.filter(content => content.contentType === 19 && content.geoNames !== '').sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title)).sort((a, b) => a.geoNames != null && b.geoNames != null && a.geoNames.localeCompare(b.geoNames))} />
                <ShowCompanyOrAuthAdvisers relatedContents={this.props.content.relatedContents.filter(content => content.contentType === 15)
                  .sort((a, b) => a.orderBy - b.orderBy)
                  .sort((a, b) => a.title_2 != null && b.title_2 != null && a.title_2.localeCompare(b.title_2))
                  .sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title))
                } sectionHeader='Companies/Other Parties and Advisers' />
                <ShowCompanyOrAuthAdvisers relatedContents={this.props.content.relatedContents.filter(content => content.contentType === 19)
                  .sort((a, b) => a.orderBy - b.orderBy)
                  .sort((a, b) => a.title_2 != null && b.title_2 != null && a.title_2.localeCompare(b.title_2))
                  .sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title))
                } sectionHeader='Authorities and Advisers' />
                <ShowCourtsAndJudiciaries courts={this.props.content.relatedContents.filter(content => content.contentType === 14).sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title))} />
              </div>
              <div className='grid-content-center content-article portfolio'>
                <ShowInBrief inBrief={this.props.content.fullText} truncateText={false} />
                <ShowRelatedContent relatedContents=
                  {
                    (this.state.relatedContentsToShow.length === 0 && this.state.selectedContentTypeIds.length === 0 && this.state.selectedGeographyIds.length === 0) ?
                      this.props.content.relatedContents.filter(content => content.contentType == 4 || content.contentType == 5 || content.contentType == 7 || content.contentType == 9).sort((a, b) => a.publishedDate != null && b.publishedDate != null && b.publishedDate.localeCompare(a.publishedDate))
                      :
                      this.state.relatedContentsToShow.filter(content => content.contentType == 4 || content.contentType == 5 || content.contentType == 7 || content.contentType == 9).sort((a, b) => a.publishedDate != null && b.publishedDate != null && b.publishedDate.localeCompare(a.publishedDate))
                  } relatedContentDataLength={this.props.content.relatedContents.filter(content => content.contentType == 4 || content.contentType == 5 || content.contentType == 7 || content.contentType == 9).length} />
                <ShowAttachments attachments={this.props.content.attachments} />
                <ShowRelatedPortfolios relatedContents={this.props.content.relatedContents.filter(content => content.contentType == 6).sort((a, b) => a.publishedDate != null && b.publishedDate != null && b.publishedDate.localeCompare(a.publishedDate))} />
                <div className='article-tags'>
                  <div className='article-tag'>
                    <ShowCategories title='Areas of Interest' categories={this.props.user.profile.Role == EDITORIALACCESS ? this.props.content.categories.filter(category => category.type === 20) : this.props.content.categories.filter(category => category.type === 20 && !AOISTOIGNORE.includes(category.id))} />
                  </div>
                  <div className='article-tag'>
                    <ShowCategories title='Industries' categories={this.props.content.categories.filter(category => category.type === 3)} />
                  </div>
                  <div>
                    <ShowTopics title='Topics' topics={this.props.content.keywords}></ShowTopics>
                  </div>
                </div>
              </div>
            </>
          )
        }

        if (this.props.content.contentTypeName === 'Court'
          || this.props.content.contentTypeName === 'Firm' 
          || this.props.content.contentTypeName === 'Judiciary' 
          || this.props.content.contentTypeName === 'Law Firm'
          || this.props.content.contentTypeName === 'Lawyer' 
          || this.props.content.contentTypeName === 'Regulator'
          || this.props.content.contentTypeName === 'Person'
          || this.props.content.contentTypeName === 'Other Entity'
          )  {
          document.title = "MLex | " + this.props.content.title
          var entity = ''
          switch(this.props.content.contentTypeName.toLowerCase()) {
            case 'firm': case 'other entity':
              entity = 'company'          
              break
            case 'lawyer': case 'person': case 'judiciary':
              entity = 'individual'
              break
            case 'regulator':
                entity = 'authority'
                break              
            default:
              entity = this.props.content.contentTypeName.toLowerCase()  
          }
          return (
            <>
              <div className='grid-content-header content-article'>
                <ShowContentActionButtons contentId={this.props.match.params.id} preferences={this.props.preferences}
                  userRole={userRole} userEmail={userEmail} contentTitle={this.props.content.title} isEntity onPdfButtonClick={(req) => this.callPdfFetch(req)} apiResponse={this.props.fetchPdf}
                  contentTypeName={this.props.content.contentTypeName} aoi={this.props.content.categories.filter(category => category.type === 20).map(cat => cat.name)}/>

                <h1 className='article-title'>{this.props.content.title || <Skeleton count={2} />}</h1>                
              </div>

              <div className='grid-content-full content-article portfolio'>
                <ShowInBrief inBrief={`This ${entity}  is tagged on the following Portfolios.`} truncateText={false} />                  
                <div className='related-portfolios-label'><strong>Related Portfolio(s): </strong></div>
                  <ShowRelatedContent hideTitle={true} showAOIs={true} relatedContents=
                    {
                      [...new Map(this.props.content.relatedContents
                        .filter(content => content.contentType == 6)
                        .sort((a, b) => a.publishedDate != null && b.publishedDate != null && b.publishedDate.localeCompare(a.publishedDate))
                        .map(item => [item['id'], item])).values()]
                    } relatedContentDataLength={this.props.content.relatedContents.filter(content => content.contentType == 6).length} />                 
              </div>
            </>
          )
        }

        if (this.props.content.contentTypeName != 'Conference') {
          document.title="MLex | " + this.props.content.title
        } else {
          document.title="MLex | Conference Listings | " + this.props.content.title
        }
        return (
          <>
            <div className='grid-content-header content-article'>
              <ShowContentActionButtons contentId={this.props.match.params.id} preferences={this.props.preferences}
                userRole={userRole} userEmail={userEmail} contentTitle={this.props.content.title} onPdfButtonClick={(req) => this.callPdfFetch(req)} apiResponse={this.props.fetchPdf}
                contentTypeName={this.props.content.contentTypeName} aoi={this.props.content.categories.filter(category => category.type === 20).map(cat => cat.name)}/>

              <h1 className='article-title'>{this.props.content.title || <Skeleton count={2} />}</h1>
              <div className='article-published '>          
              <ShowPublished published={this.props.content.published} contentTypeName={this.props.content.contentTypeName} productType={this.props.user.profile.Product} showTooltip={true} />
                {(this.props.content.contentTypeName == 'Conference') &&                 
                  <div className='article-conference-detail '>
                    <div><b>Date: </b>{displayDate(this.props.content.eventDate)}</div>
                    <div><b>Location: </b>{this.props.content.location}</div>
                  </div>                 
                }
              </div>
              <ShowAuthor author={this.props.content.author} clickable={true}/>
            </div>

            <div className='grid-content-full content-article'>
              {(this.props.content.contentTypeName !== 'Conference') ?
              <>               
                  <ShowInBrief inBrief={this.props.content.introduction} truncateText={false} />            
                  <ShowFullText fullText={this.props.content.fullText} />
              </>
              :
              <>
                <ShowFullText fullText={addTargetToLinks(this.props.content.fullText)} />
                <ShowAttachments attachments={this.props.content.attachments} />
              </>
              }
             
              {(this.props.content.contentTypeName != 'Conference') &&
                <>
                <ShowPressSource pressSource={this.props.content.relatedContents.filter(content => content.contentType === 26).sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title))} />               
                <ShowAttachments attachments={this.props.content.attachments} />
                {(this.props.content.contentTypeName == 'Official Statement') &&
                  <div className={this.props.content.attachments.length > 0 ? '' : 'article-issuingEntity'}>
                    <ShowIssuingEntities label='Issuing Entity(ies)' entities={this.props.content.relatedContents
                      .filter(content => (content.contentType === 14 /*Court*/ || content.contentType === 15 /*Company*/ || content.contentType === 17 /*LawFirm*/ || content.contentType === 19 /*Regulator*/ || content.contentType === 21 /*Person*/ || content.contentType === 24 /*Other Entity*/)
                        && content.relatedContentId_2 === 0 && content.relatedContentId_3 === 0 && content.id === content.relatedContentId)
                      .map(rc => ({ id: rc.id, title: rc.title, isImportant: rc.isImportant }))
                      .sort((a, b) => a.title != null && b.title != null && a.title.localeCompare(b.title))} />
                    <div>
                      <ShowDocumentTypes doctypes={this.props.content.documentTypes.sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))} />
                    </div>
                  </div>
                }          
                <ShowPortfolios relatedContents={[...new Map(this.props.content.relatedContents.filter(content => content.contentType == 6).sort((a, b) => a.publishedDate != null && b.publishedDate != null && b.publishedDate.localeCompare(a.publishedDate)).map(item => [item['id'], item])).values()]} />
                </>                
              }<div className='article-tags'>
                <div className='article-tag'>
                <ShowCategories title='Areas of Interest' categories={this.props.user.profile.Role == EDITORIALACCESS ? this.props.content.categories.filter(category => category.type === 20) : this.props.content.categories.filter(category => category.type === 20 && !AOISTOIGNORE.includes(category.id))} />
                </div>
                {(this.props.content.contentTypeName != 'Conference') &&
                <>
                <div className='article-tag'>
                  <ShowCategories title='Industries' categories={this.props.content.categories.filter(category => category.type === 3)} />
                </div>
                <div className='article-tag'>
                  <ShowCategories title='Geographies' categories={this.props.content.categories.filter(category => category.type === 7 || category.type === 5 || category.type === 6)} />
                </div>                
                <div>
                  <ShowTopics title='Topics' topics={this.props.content.keywords}></ShowTopics>
                </div>
                </>
                }
              </div>
            </div>
          </>
        )
      } else {
        return (
          <div className='grid-content-full skeleton content-article'>
            <div className=''>
              <Skeleton height={40} count={1} /><br /><br />
              <Skeleton count={2} /><br /><br />
              <Skeleton count={5} /><br /><br />
              <Skeleton count={10} />
            </div>
          </div>
        )

      }
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    content: state.content,
    preferences: state.userPreferences,
    fetchPdf: state.fetchPdf
  }
}

const mapDispatchToProps = (dispatch) => ({
  onContentFetch: (payload) => new Promise((resolve, reject) => {
    dispatch(actions.fetchContent(payload)).then(() => {
      resolve();
    })
  }),
  onPrefsFetch() {
    dispatch(actions.fetchPreferences())
  },
  onPdfFetch: (payload) => new Promise((resolve, reject) => {
    dispatch(actions.fetchAndSavePdfContent(payload)).then(() => {
      resolve();
    })
  })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content)
